import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, ChevronDown, Globe, Menu, X, Code } from 'lucide-react';

// Trustpilot logo URL (SVG)
const TRUSTPILOT_LOGO = '/images/trustpilot-logo.svg';

const Header = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="bg-[#191919] sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center gap-6">
            <a href="/" className="flex items-center gap-2">
              <img 
                src={TRUSTPILOT_LOGO} 
                alt="Trustpilot" 
                className="h-8 w-auto"
              />
            </a>
          </div>

          {/* Search Bar - Desktop */}
          <div className="hidden md:flex flex-1 max-w-2xl mx-8">
            <div className="relative w-full">
              <div className="flex items-center bg-white rounded-full overflow-hidden">
                <input
                  type="text"
                  placeholder="Rechercher une entreprise ou une catégorie"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full px-4 py-2.5 text-sm text-gray-900 placeholder-gray-500 focus:outline-none"
                />
                <button className="px-4 py-2.5 bg-white hover:bg-gray-50 transition-colors">
                  <Search className="w-5 h-5 text-gray-600" />
                </button>
              </div>
            </div>
          </div>

          {/* Right Side - Desktop */}
          <div className="hidden md:flex items-center gap-4">
            <button 
              onClick={() => navigate('/widgets')}
              className="flex items-center gap-1 text-white text-sm hover:text-gray-300 transition-colors"
            >
              <Code className="w-4 h-4" />
              <span>Widgets</span>
            </button>
            <button className="flex items-center gap-1 text-white text-sm hover:text-gray-300 transition-colors">
              <span>Catégories</span>
              <ChevronDown className="w-4 h-4" />
            </button>
            <button className="flex items-center gap-1 text-white text-sm hover:text-gray-300 transition-colors">
              <span>Blog</span>
            </button>
            <div className="h-6 w-px bg-gray-600"></div>
            <button className="flex items-center gap-1 text-white text-sm hover:text-gray-300 transition-colors">
              <span>Pour les entreprises</span>
            </button>
            <button className="text-white text-sm hover:text-gray-300 transition-colors">
              Connexion
            </button>
            <button className="flex items-center gap-1.5 text-white text-sm hover:text-gray-300 transition-colors">
              <Globe className="w-4 h-4" />
              <span>FR</span>
              <ChevronDown className="w-4 h-4" />
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-700">
            <div className="relative mb-4">
              <input
                type="text"
                placeholder="Rechercher une entreprise"
                className="w-full px-4 py-2.5 text-sm rounded-full text-gray-900 placeholder-gray-500 focus:outline-none"
              />
            </div>
            <nav className="flex flex-col gap-3">
              <a href="#" className="text-white text-sm hover:text-gray-300">Catégories</a>
              <a href="#" className="text-white text-sm hover:text-gray-300">Blog</a>
              <a href="#" className="text-white text-sm hover:text-gray-300">Pour les entreprises</a>
              <a href="#" className="text-white text-sm hover:text-gray-300">Connexion</a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
